import React from 'react';

export const Currency = ({ value }: { value?: number }) => {
  if (value === undefined) return null;

  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);

  return <>{formattedValue}</>;
};
